<template>
  <!-- NOTE: ホバー判定は祖先要素の group クラスに依存する。呼び出し側で group と relative を付けること -->
  <span
    class="invisible absolute left-full top-1/2 z-20 ml-1 -translate-y-1/2 px-3 py-2 text-white text-sm whitespace-nowrap bg-gray-700 rounded opacity-0 transition-opacity duration-150 ease-in group-hover:visible group-hover:opacity-100 motion-reduce:transition-none pointer-events-none before:content-[''] before:absolute before:left-[-3px] before:top-1/2 before:w-2 before:h-2 before:-translate-y-1/2 before:rotate-45 before:bg-gray-700"
    role="tooltip"
  >
    <slot />
  </span>
</template>
